function useStyles() {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            alignItems: 'center',
            padding: 3,
            paddingTop: 0,
            position: 'relative'
        },
        icon: {
            fontSize: '3rem',
            width: '3rem',
            height: '3rem',
            overflow: 'visible',
            '& .MuiSvgIcon-root': {
                fontSize: 'inherit',
                width: 'inherit',
                height: 'inherit',
            }
        },
        close: {
            position: 'absolute',
            top: '-5px',
            right: '5px',
        }
    }
}

export { useStyles }